export default __webpack_public_path__ + "static/media/eym_it.b2a79ff2.svg";